import React from "react";
import QuestionLayout from "./QuestionLayout";
import { selectOptions } from "../utils/selectInput.js";
import { examAssetUrl } from "../utils/examAssetUrl.js";

export default function SelectInputWidget({ config, value = "", onChange, mode = "edit", feedback }) {
  const options = selectOptions(config);
  const image = config.image && <img key={config.image} src={examAssetUrl(config.image)} alt={config.imageAlt || "Musical excerpt"}
    style={{display:"block",width:Number(config.imageWidth) || 560,maxWidth:"100%",height:"auto",marginBottom:24}} />;
  if (Array.isArray(config.rows)) return (
    <QuestionLayout number={config.number} prompt={config.prompt} points={config.points} mode={mode} feedback={feedback}>
      {image}
      <div style={{display:"flex",alignItems:"center",gap:32,flexWrap:"wrap"}}>
        <div style={{display:"grid",gridTemplateColumns:"max-content minmax(160px, 210px)",alignItems:"center",gap:"20px 20px"}}>
          {config.rows.map(row=>{
            const saved=typeof value?.[row.id] === "string" ? value[row.id] : "";
            const part=feedback?.parts?.find(p=>p.id===row.id);
            return <React.Fragment key={row.id}>
              <span style={{fontSize:22,letterSpacing:2,whiteSpace:"nowrap"}}>{row.label}</span>
              <select aria-label={`Scale name for ${row.label}`} value={saved} disabled={mode!=="edit"}
                onChange={event=>onChange({...((value && typeof value === "object") ? value : {}),[row.id]:event.target.value})}
                style={{fontSize:16,padding:"8px 10px",borderRadius:6,border:mode==="review" && part?`2px solid ${part.correct?"#2e7d32":"#c62828"}`:"1px solid #aaa"}}>
                <option value="">{config.placeholder || "Scale name"}</option>
                {saved && !options.includes(saved) && <option value={saved} disabled>{saved}</option>}
                {options.map(option=><option key={option} value={option}>{option}</option>)}
              </select>
            </React.Fragment>;
          })}
        </div>
        {config.legendImage && <img src={config.legendImage} alt={config.legendImageAlt || "Scale Name Bank"}
          style={{width:config.legendImageWidth || 340,maxWidth:"100%",height:"auto",display:"block"}} />}
      </div>
    </QuestionLayout>
  );
  const saved = typeof value === "string" ? value : "";
  const stale = saved !== "" && !options.includes(saved);
  const part = feedback?.parts?.[0];
  return (
    <QuestionLayout number={config.number} prompt={config.prompt} points={config.points} mode={mode} feedback={feedback}>
      {image}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <select
          aria-label={`Answer${config.number ? ` for question ${config.number}` : ""}`}
          value={saved}
          disabled={mode !== "edit"}
          onChange={event => onChange(event.target.value)}
          style={{
            fontSize: 16, padding: "8px 10px", borderRadius: 6, maxWidth: "100%",
            border: mode === "review" && part
              ? `2px solid ${part.correct ? "#2e7d32" : "#c62828"}`
              : "1px solid #aaa",
          }}
        >
          <option value="">{config.placeholder || "Select an answer…"}</option>
          {stale && <option value={saved} disabled>{saved} (no longer available)</option>}
          {options.map(option => <option key={option} value={option}>{option}</option>)}
        </select>
        {config.suffix && <span style={{ fontSize: 16, fontWeight: "bold" }}>{config.suffix}</span>}
      </div>
    </QuestionLayout>
  );
}
